import React from 'react';

import { useAuth } from 'src/Hooks/Authentication/useAuth';
import { useAuthenticatedUser } from 'src/Hooks/Authentication/useAuthenticatedUser';

import AdminParametersPopOverMenu from './AdminParametersPopOverMenu.component';

const MemoAdminParametersPopOverMenu = React.memo(AdminParametersPopOverMenu);

const EnhancedAdminParametersPopOverMenu = () => {
  const { logout } = useAuth();
  const { givenName, familyName, email } = useAuthenticatedUser();

  return (
    <MemoAdminParametersPopOverMenu
      firstName={givenName}
      lastName={familyName}
      email={email}
      onLogout={() =>
        logout({ logoutParams: { returnTo: process.env.REACT_APP_AUTH0_REDIRECT_URI } })
      }
    />
  );
};

export default EnhancedAdminParametersPopOverMenu;
